module.exports = __webpack_public_path__ + "static/img/european-year.9db16e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners/european-year.png
// module id = n//d
// module chunks = 1